export default "__VITE_ASSET__07b0e04f__"